import { Box, styled } from '@mui/material';
import { fontWeight } from '@app/theme/typography';
import { palette } from '@app/theme/palette';

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'bgColour' && prop !== 'bgOpacity',
})<{
  bgColour?: string;
  color?: string;
  bgOpacity?: number;
}>`
  align-items: center;
  background-color: ${(props) =>
    props.bgColour
      ? props.bgColour + String((props.bgOpacity ?? 1) * 100)
      : palette.collection.grey.d250};
  border-radius: 5px;
  color: ${(props) => (props.color ? props.color : palette.custom.darkGrey)};
  display: inline-flex;
  gap: 6px;
  justify-content: center;
  padding: 4px 8px;
  text-align: center;
  font-size: 10px;
  font-weight: ${fontWeight.bold};
  line-height: normal;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  min-height: 26px;
`;
